module.exports = __webpack_public_path__ + "img/img2.c7695505.png";